module.exports = __webpack_public_path__ + "img/ic_star_border_24px.1e1b28ef.svg";